export const APP_MODAL_OPEN = 'app:modal:open'
export const SIMPLE = 'modalSimple'
export const TRIAL_TO_BASIC = 'trialToBasic'
export const RECOMMENDATION = 'recommendation'
export const SECRET_QUESTION = 'secret-question'

export default {
  SIMPLE,
  TRIAL_TO_BASIC,
  RECOMMENDATION,
  SECRET_QUESTION,
  APP_MODAL_OPEN,
}
